function onFlightResultPageReady() {

    var isContentItemsHidden, locationContentElement;

    isContentItemsHidden = true;

//    $('#flightlocationtitle').mouseenter(function () {
//        if (isContentItemsHidden) {
//            $('.contentitems').show('slide', { direction: 'down' }, 1000);
//            setTimeout(function () { isContentItemsHidden = false; }, 1200);
//        }
//    });

    $('.flightcontentholder').mouseleave(function () {
        if (!isContentItemsHidden) {
            setTimeout(
            function () {
                $('.contentitems').hide('slide', { direction: 'down' }, 1000);
            }, 1000);
            setTimeout(function () { isContentItemsHidden = true; }, 1100);
        }
    });

    $('#contentitems').click(function () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            setTimeout(
                function () {
                    $('.contentitems').hide('slide', { direction: 'down' }, 1000);
                }, 1000);
            setTimeout(function () { isContentItemsHidden = true; }, 1100);
        }        
    });

    $('#gmapopen').click(function () {
        googleMapInitialize();        
    });

    $('#tempopen').click(function () {
        initializeTemperature();
    });

    $('#magazineopen').click(function () {
        document.getElementById('magslidecover').style.display = 'block';
        document.getElementById('magslidecover').style.height = $('#magazinelinkholder').css('height');
        document.getElementById('magslidecover').style.zIndex = 30;
        $('#magazinelinkholder').show('slide', { direction: 'down' }, 200);
    });

    $('#magazinelinkholder').mouseleave(function () {
        $('#magazinelinkholder').hide('slide', { direction: 'down' }, 200);
        setTimeout(function () {
            document.getElementById('magslidecover').style.display = 'none';
            document.getElementById('magslidecover').style.height = '930px';
            document.getElementById('magslidecover').style.zIndex = 0;
        }, 310);
    });

    $('#magazinelinkholder').click(function () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            $('#magazinelinkholder').hide('slide', { direction: 'down' }, 200);
            setTimeout(function () {
                document.getElementById('magslidecover').style.display = 'none';
                document.getElementById('magslidecover').style.height = '930px';
                document.getElementById('magslidecover').style.zIndex = 0;
            }, 310);
        }
    });
}

function onCarResultPageReady() {
    var isCarGuideHidden = true;
    var isCarContentItemsHidden = true;

    $('#gmapopen').click(function () {
        googleMapInitialize();
    });

    $('#tempopen').click(function () {
        initializeTemperature();
    });

    $('#magazineopen').click(function () {
        document.getElementById('magslidecover').style.display = 'block';
        document.getElementById('magslidecover').style.height = $('#magazinelinkholder').css('height');
        document.getElementById('magslidecover').style.zIndex = 30;
        $('#magazinelinkholder').show('slide', { direction: 'down' }, 200);
    });

    $('#magazinelinkholder').mouseleave(function () {
        $('#magazinelinkholder').hide('slide', { direction: 'down' }, 200);
        setTimeout(function () {
            document.getElementById('magslidecover').style.display = 'none';
            document.getElementById('magslidecover').style.height = '930px';
            document.getElementById('magslidecover').style.zIndex = 0;
        }, 310);
    });

    $('#magazinelinkholder').click(function () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            $('#magazinelinkholder').hide('slide', { direction: 'down' }, 200);
            setTimeout(function () {
                document.getElementById('magslidecover').style.display = 'none';
                document.getElementById('magslidecover').style.height = '930px';
                document.getElementById('magslidecover').style.zIndex = 0;
            }, 310);
        }
    });

    $('#carhireguidelink').click(function () {
        if (isCarGuideHidden) {
            $('#carhireinfo').show('slide', { direction: 'down' }, 1000);
            setTimeout(function () { isCarGuideHidden = false; }, 1200);
        }
    });

    $('#carhireinfo').mouseleave(function () {
        if (!isCarGuideHidden) {
            setTimeout(
            function () {
                $('#carhireinfo').hide('slide', { direction: 'down' }, 1000);
            }, 1000);
            setTimeout(function () { isCarGuideHidden = true; }, 1100);
        }
    });

    $('#carhireinfo').click(function () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            if (!isCarGuideHidden) {
                setTimeout(
            function () {
                $('#carhireinfo').hide('slide', { direction: 'down' }, 1000);
            }, 1000);
                setTimeout(function () { isCarGuideHidden = true; }, 1100);
            }
        }
    });

    $('#flightlocationtitle').mouseenter(function () {
        if (isCarContentItemsHidden) {
            $('.contentitems').show('slide', { direction: 'down' }, 1000);
            setTimeout(function () { isCarContentItemsHidden = false; }, 1200);
        }
    });

    $('.flightcontentholder').mouseleave(function () {
        if (!isCarContentItemsHidden) {
            setTimeout(
            function () {
                $('.contentitems').hide('slide', { direction: 'down' }, 1000);
            }, 1000);
            setTimeout(function () { isCarContentItemsHidden = true; }, 1100);
        }
    });

    $('#contentitems').click(function () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            setTimeout(
                function () {
                    $('.contentitems').hide('slide', { direction: 'down' }, 1000);
                }, 1000);
            setTimeout(function () { isCarContentItemsHidden = true; }, 1200);
        }
    });

}

function carsOfferSlider() {
    var offerHolderOneCount = $('#advholderone').children().length;
    var offerHolderTwoCount = $('#advholdertwo').children().length;
    if (offerHolderOneCount > 1) {
        var $active1 = $('#advholderone div.active');
        if ($active1.length === 0) $active1 = $('#advholderone div:last');
        var $next1 = $active1.next().length ? $active1.next() : $('#advholderone div:first');
        $active1.addClass('last-active');
        $next1.css({ opacity: 0.0 })
        .addClass('active')
        .animate({ opacity: 1.0 }, 1000, function () {
            $active1.removeClass('active last-active');
        });
    }

    if (offerHolderTwoCount > 1) {
        var $active2 = $('#advholdertwo div.active');
        if ($active2.length === 0) $active2 = $('#advholdertwo div:last');
        var $next2 = $active2.next().length ? $active2.next() : $('#advholdertwo div:first');
        $active2.addClass('last-active');
        $next2.css({ opacity: 0.0 })
        .addClass('active')
        .animate({ opacity: 1.0 }, 1000, function () {
            $active2.removeClass('active last-active');
        });
    }
}

function holidayOffersFade(obj) {
    var offerHolderOneCount = $('#fadeholder').children().length;
    var currentDisplayOffer = $('#displayeoffer').val();
    if (offerHolderOneCount > 1 && currentDisplayOffer != obj) {
        var $currentActive = $('#fadeholder div.active');
        var $select = $('#' + obj);
            $currentActive.addClass('last-active');
            $select.css({ opacity: 0.0 })
                .addClass('active')
                .animate({ opacity: 1.0 }, 300, function () {
                  $currentActive.removeClass('active last-active');
              });
              $('#displayeoffer').val(obj);
    }
}

function autoFadeEffect(id) {
    var $active = $('#' + id + ' img.active');
    if ($active.length === 0) $active = $('#' + id + ' img:last');
    var $next = $active.next().length ? $active.next() : $('#' + id + ' img:first');
    $active.addClass('last-active');
    $next.css({ opacity: 0.0 })
        .addClass('active')
        .animate({ opacity: 1.0 }, 1500, function () {
            $active.removeClass('active last-active');
        });
}








